module.exports = __webpack_public_path__ + "img/math_on.1d20659b.svg";